import * as style from './style.css';
import * as shared from '../../styledApplication/style.css';
import ExpandMoreIcon from '../../assets/icons/ExpandMoreIcon';
import classes from '../../framework/framework/tools/classes';
import React = require('react');

export enum Visibility{
    Small=1,
    Medium= 1 << 1,
    XLarge = 1 << 2
}
interface IProps {
    label: string;
    link: string;
    visibility? : Visibility;
}
interface IState {

}

export default class LinkAnchor extends React.Component<IProps, IState> {
    render() {
        const s = (this.props.visibility & Visibility.Small) ? shared.small : '';
        const m = (this.props.visibility & Visibility.Medium) ? shared.medium : '';
        const xl = (this.props.visibility & Visibility.XLarge) ? shared.xlarge : '';
        return (
            <a className={classes(style.anchorLink, s, m, xl)} href={'#' + this.props.link}>
                <div className={style.anchorLink}>{this.props.label} <ExpandMoreIcon /></div>
            </a>
        );
    }
}
